import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RemoveScannedItemsFromSessionMutationVariables = Types.Exact<{
  sessionId: Types.Scalars['ID'];
  containerIds: Array<Types.Scalars['ID']> | Types.Scalars['ID'];
  itemIds: Array<Types.Scalars['ID']> | Types.Scalars['ID'];
}>;


export type RemoveScannedItemsFromSessionMutation = { __typename?: 'Mutation', removeScannedItemsFromSession: { __typename?: 'ScanTunnelSession', id: string, scan_tunnel_id: string, active_until?: string | null, is_active: boolean, containers: Array<{ __typename?: 'ContainerStationContainer', id: string, name: string, status: Types.ContainerLocationStatus, type_id: number, type_name: string, image_url?: string | null }>, container_stations: Array<{ __typename?: 'ContainerStation', id: string, name: string }> } };


export const RemoveScannedItemsFromSessionDocument = gql`
    mutation removeScannedItemsFromSession($sessionId: ID!, $containerIds: [ID!]!, $itemIds: [ID!]!) {
  removeScannedItemsFromSession(
    session_id: $sessionId
    container_ids: $containerIds
    item_ids: $itemIds
  ) {
    id
    scan_tunnel_id
    active_until
    is_active
    containers {
      id
      name
      status
      type_id
      type_name
      image_url
    }
    container_stations {
      id
      name
    }
  }
}
    `;
export type RemoveScannedItemsFromSessionMutationFn = Apollo.MutationFunction<RemoveScannedItemsFromSessionMutation, RemoveScannedItemsFromSessionMutationVariables>;

/**
 * __useRemoveScannedItemsFromSessionMutation__
 *
 * To run a mutation, you first call `useRemoveScannedItemsFromSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveScannedItemsFromSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeScannedItemsFromSessionMutation, { data, loading, error }] = useRemoveScannedItemsFromSessionMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *      containerIds: // value for 'containerIds'
 *      itemIds: // value for 'itemIds'
 *   },
 * });
 */
export function useRemoveScannedItemsFromSessionMutation(baseOptions?: Apollo.MutationHookOptions<RemoveScannedItemsFromSessionMutation, RemoveScannedItemsFromSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveScannedItemsFromSessionMutation, RemoveScannedItemsFromSessionMutationVariables>(RemoveScannedItemsFromSessionDocument, options);
      }
export type RemoveScannedItemsFromSessionMutationHookResult = ReturnType<typeof useRemoveScannedItemsFromSessionMutation>;
export type RemoveScannedItemsFromSessionMutationResult = Apollo.MutationResult<RemoveScannedItemsFromSessionMutation>;
export type RemoveScannedItemsFromSessionMutationOptions = Apollo.BaseMutationOptions<RemoveScannedItemsFromSessionMutation, RemoveScannedItemsFromSessionMutationVariables>;